import { defineMessages } from 'react-intl';

const messages = defineMessages({
  AwaitingShipment: {
    description: 'Status for a return request waiting for items to be shipped back to the merchant/warehouse/physical store.',
    defaultMessage: 'Awaiting Shipment',
    id: 'T4FtZv',
  },
  PendingAtAdmin: {
    description: 'Status for a return request waiting for final admin approval',
    defaultMessage: 'Pending at Admin',
    id: 'zSzU1j',
  },
  PendingAtStore: {
    description: 'Status for a return request that is waiting to be approved at a physical store.',
    defaultMessage: 'Pending at Store',
    id: 'cyGPIl',
  },
  PendingAtWarehouse: {
    description: 'Status for a return request received at warehouse for inspection prior to approval',
    defaultMessage: 'Pending at Warehouse',
    id: 'SvcLV4',
  },
  PendingCompletion: {
    description: 'Status for a return request that was started but not submitted.',
    defaultMessage: 'Pending Completion',
    id: 'VGcaS0',
  },
  PendingDelivery: {
    description: 'Status for a return request waiting for items to be shipped back to the merchant/warehouse/physical store.',
    defaultMessage: 'Pending Delivery',
    id: '11oVc4',
  },
  PendingPaymentCompletion: {
    description: 'Status for a return request pending payment completion',
    defaultMessage: 'Pending Payment Completion',
    id: '1m6TSQ',
  },
  Processed: {
    description: 'Status for a return request that was processed and completed.',
    defaultMessage: 'Processed',
    id: 'zVXY2k',
  },
  Cancelled: {
    description: 'Status for a return request that was cancelled',
    defaultMessage: 'Cancelled',
    id: 'YWPxVF',
  },
});

export const EnhancedReturnStatus = {
  AwaitingShipment: {
    translation: messages.AwaitingShipment,
    key: 'PENDING_QUALIFICATION',
  },
  PendingAtAdmin: {
    translation: messages.PendingAtAdmin,
    key: 'PENDING_AT_ADMIN',
  },
  PendingAtStore: {
    translation: messages.PendingAtStore,
    key: 'PENDING_AT_STORE',
  },
  PendingAtWarehouse: {
    translation: messages.PendingAtWarehouse,
    key: 'PENDING_AT_WAREHOUSE',
  },
  PendingCompletion: {
    translation: messages.PendingCompletion,
    key: 'PENDING_COMPLETION',
  },
  PendingDelivery: {
    translation: messages.PendingDelivery,
    key: 'PENDING_DELIVERY',
  },
  PendingPaymentCompletion: {
    translation: messages.PendingPaymentCompletion,
    key: 'PENDING_PAYMENT_COMPLETION',
  },
  Processed: {
    translation: messages.Processed,
    key: 'PROCESSED',
  },
  Cancelled: {
    translation: messages.Cancelled,
    key: 'CANCELLED',
  },
};
